import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import api from '../api/api'
import "quill/dist/quill.core.css"


Vue.prototype.$api = api

Vue.config.productionTip = false
Vue.use(ElementUI);
// router.afterEach((to,from,next)=>{
//   window,scrollTo(0,0)
// })
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
